import styled from '@emotion/styled';
import { Avatar, tokens } from '@hotjar/hotsauce';

// FIXME: consider move of the ReactionGroupComponent to the Highlights feature
import { ReactionGroup } from '@hotjar/webapp/features/Playbacks/ReactionGroup/ReactionGroup';
import { getReactionNameById } from '@hotjar/webapp/features/Playbacks/ReactionIcons';
import type { ReactionNameEnum } from '@hotjar/webapp/features/Playbacks/ReactionIcons';
import { getUserAvatarUrl } from '@hotjar/insights-common/lib/getUserAvatarUrl';
import { useFeatureFlag } from '@hotjar/webapp/hooks/useFeatureFlag';
import { useAvailableLabels } from '@hotjar/labels';
import { useCurrentSiteId } from '@hotjar/site';
import { CustomLabelReactionGroup } from '../../Playbacks/ReactionGroup/V2/CustomLabelReactionGroup';

const AvatarButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${tokens.color.ui_background};
  border: 3px solid ${tokens.color.white};
  border-radius: 50%;
  outline: none;
  padding: 0;
  ${tokens.elevation(3)}
`;

interface HighlightIndicatorProps {
  className?: string;
  onClick: () => void;
  onMouseEnter: () => void;
  showReactionIcon?: boolean;
  author: {
    avatar: string;
    name: string;
  };
  hasComments?: boolean;
  labels?: string[];
}

export const HighlightIndicator = ({
  className,
  onClick,
  onMouseEnter,
  showReactionIcon,
  author,
  labels = [],
  hasComments,
}: HighlightIndicatorProps): JSX.Element => {
  const isCustomLabelsAllowed = useFeatureFlag('settings.custom-labels');

  const siteId = useCurrentSiteId();
  const { data: availableLabels } = useAvailableLabels(
    siteId,
    isCustomLabelsAllowed ? 'all' : 'default',
  );

  if (showReactionIcon && labels.length > 0) {
    const labelNames = labels.map((labelId) => getReactionNameById(labelId));
    const commenters = hasComments ? [author] : [];

    return !isCustomLabelsAllowed ? (
      <ReactionGroup
        className={className}
        commenters={commenters}
        reactions={labelNames as ReactionNameEnum[]}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
      />
    ) : (
      <CustomLabelReactionGroup
        className={className}
        commenters={commenters}
        highlightLabelIds={labels}
        availableLabels={availableLabels ?? []}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
      />
    );
  }

  return (
    <AvatarButton className={className} type="button" onClick={onClick} onMouseEnter={onMouseEnter}>
      <Avatar src={getUserAvatarUrl(author)} userName={author.name} size="l" hideTooltip />
    </AvatarButton>
  );
};
